export function BambiShortLogo() {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 14 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3_10685)">
        <path
          d="M11.0994 10.2632C11.6062 10.3752 12.0491 10.6681 12.5049 10.961C13.7485 11.7665 14.43 12.9165 14.5365 14.4284C14.6387 15.8714 14.4939 17.2412 13.8167 18.5549C13.3098 19.537 12.5049 20.1357 11.5636 20.5923C10.6223 21.0489 9.62143 21.2901 8.5822 21.2987C5.8521 21.3203 0.09375 21.3116 0.09375 21.3116C0.09375 21.3116 5.49007 17.0129 8.17333 14.8936C8.46721 15.277 8.72276 15.6431 9.01238 15.9705C9.1146 16.0868 9.31904 16.1988 9.44681 16.1686C9.57032 16.1385 9.71939 15.9446 9.75347 15.7982C10.1581 14.0709 11.1036 10.2632 11.1036 10.2632H11.0994Z"
          fill="#00B7B5"
        />
        <path
          d="M11.0652 10.1645C11.0099 9.97495 10.8565 9.85865 10.5882 9.85004C8.77808 9.80266 7.35978 9.78543 5.18763 9.74235C4.71486 9.73374 4.58709 9.98788 4.85967 10.3928C5.14929 10.8192 5.46447 11.2241 5.79242 11.6807C3.86729 13.1926 1.96772 14.6872 0 16.2336V0.62792C0.183143 0.614998 0.353508 0.597768 0.523874 0.597768C2.67048 0.597768 4.81708 0.576231 6.96369 0.602076C8.47994 0.619305 9.97915 0.894978 11.3506 1.6057C12.9733 2.44995 13.7102 3.87569 13.7783 5.67187C13.8464 7.52405 13.0585 8.91964 11.5082 9.88881C11.3591 9.97926 11.061 10.1602 11.061 10.1602L11.0652 10.1645Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_10685">
          <rect
            width="16"
            height="20.8219"
            fill="white"
            transform="translate(0 0.588867)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
